import classNames from 'classnames'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { halfParagraphRevealAnimation } from './animations'
import { Section, WPLink } from '@/types'

type HalfParagraphProps = Section &
  Partial<{
    alignment: 'left' | 'right' | 'center'
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    paragraph: string
    button: WPLink
  }>

const HalfParagraph = ({
  alignment,
  title,
  title_variant,
  title_component,
  paragraph,
  button,
  ...props
}: HalfParagraphProps) => {
  return (
    <Motion animation={halfParagraphRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid>
              <div
                className={classNames(
                  'col-span-2 md:col-span-4 lg:col-span-6',
                  {
                    'lg:col-start-1': alignment === 'left',
                    'md:col-start-3 lg:col-start-7': alignment === 'right',
                    'md:col-start-2 lg:col-start-4': alignment === 'center'
                  }
                )}
              >
                <div className="grid gap-md">
                  {title ? (
                    <Typography
                      variant={title_variant}
                      component={title_component}
                      className="uppercase text-white [&_em]:text-blue-soft"
                      data-motion-title
                    >
                      {title}
                    </Typography>
                  ) : null}

                  {paragraph ? (
                    <Typography
                      variant="body"
                      paragraph
                      className="text-neutral-80"
                      data-motion-paragraph
                    >
                      {paragraph}
                    </Typography>
                  ) : null}

                  {button ? (
                    <div data-motion-button>
                      <Button href={button?.url} link variant="contained">
                        {button?.title}
                      </Button>
                    </div>
                  ) : null}
                </div>
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default HalfParagraph
